<template>
  <span>
    <v-card outlined>
      <v-card-text class="pa-2">
          <v-row no-gutters>
            <v-col cols=2 align-self="center">
              <v-icon left>mdi-map-marker</v-icon>
            </v-col>
            <v-col> 
              <span v-if="address1 || address2 || address3 || address4">
                {{address1}} {{address2}} {{address3}} {{address4}}
                <br>
              </span>
              <span v-if="city || stateOrProvince || postalCode">
                {{city}} {{stateOrProvince}} {{postalCode}} 
                <br>
              </span>

              <span v-if="country">
                {{country}}
              </span>
            </v-col>
          </v-row>
      </v-card-text>
    </v-card>

  </span>

</template>

<script>
export default {
  name: "Address",
  data() {
    return {};
  },
  props: {
    address1: String,
    address2: String,
    address3: String,
    address4: String,
    city: String,
    stateOrProvince: String,
    postalCode: String,
    country: String
  },
  methods: {}
};
</script>